import { store } from "@store/store";
import { fetchConfigStart } from "@store/slices/config";
import { updateLottieAnimationLoopCompletedd, skipLottieAnimation } from "@store/slices/lottieState";

export const GoToMyAccount = (args) => {
  const {
    url,
    shouldRedirect = false,
    showCustomBasicLoader = true,
    showCustomLottie = false
  } = args || {};

  const myAccountUrl = url || `${process.env.HOST_URL}/myaccount`;

  // Dispatch loader state
  if (showCustomBasicLoader) {
    store?.dispatch(fetchConfigStart({ showBasicLoader: true, showLottie: showCustomLottie }));
    store?.dispatch(updateLottieAnimationLoopCompletedd({ lottieAnimationLoopCompleted: true }));
    
    if (!showCustomLottie) {
      store?.dispatch(skipLottieAnimation({ showLottie: false }));
    }
  }

  if (shouldRedirect && window) {
    window.location.href = myAccountUrl;
  }

  return {
    shouldRedirect,
    showBasicLoader: showCustomBasicLoader,
    showLottie: showCustomLottie,
    url: myAccountUrl
  };
};